var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitechainAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1056_4017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "#E6AC17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6911 9.04065C20.7398 9.04065 19.1545 10.626 19.1545 12.5772H14.8862L18.4228 9.04065H14.1138C12.1626 9.04065 10.5772 10.626 10.5772 12.5772H10.5366C8.58537 12.5772 7 14.1626 7 16.1138H10.5772V18.7561C10.5772 22.2927 13.4634 25.1382 16.9593 25.1382H23.4634V12.5366L27 9L22.6911 9.04065ZM18.9919 18.3902C18.4634 17.8618 18.4634 17.0081 18.9919 16.4797L20.9024 18.3902C20.374 18.9187 19.5203 18.9187 18.9919 18.3902Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1056_4017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitechainAlt);
export default __webpack_public_path__ + "static/media/whitechain-alt.383761fc.svg";
export { ForwardRef as ReactComponent };